module.exports = __webpack_public_path__ + "img/zz-row-four.20c5f4d0.svg";